module.exports = __webpack_public_path__ + "media/images/confetti-right-c09c4ae4.svg";